import Auth from 'works/legacy/lib/auth';

class Filters {
  LOCALSTORAGE_KEY = 'worksFilters';
  OWNER_KEY = 'ownerId';

  constructor() {}

  getAllFilters() {
    try {
      const filtersRaw = localStorage.getItem(this.LOCALSTORAGE_KEY);
      const filters = filtersRaw ? JSON.parse(filtersRaw) : {};

      const membershipId = Auth.membershipId();
      if (filters[this.OWNER_KEY] !== membershipId) {
        return membershipId ? this.load()[membershipId] || {} : {};
      }

      return filters;
    } catch (error) {
      return {};
    }
  }

  getFilters(key: string) {
    const filters = this.getAllFilters();
    return filters[key] || {};
  }

  setFilters(key: string, filters: { [key: string]: unknown }) {
    if (!key || !filters) return;

    const currentFilters = this.getAllFilters();

    currentFilters[key] = filters;

    const membershipId = Auth.membershipId();
    if (membershipId) this.store(membershipId, currentFilters);

    return localStorage.setItem(
      this.LOCALSTORAGE_KEY,
      JSON.stringify(currentFilters)
    );
  }

  clearFilters() {
    localStorage.removeItem(this.LOCALSTORAGE_KEY);

    const membershipId = Auth.membershipId();
    if (membershipId) {
      this.store(membershipId, {});
    }
  }

  reset() {
    const initialFilters = { [this.OWNER_KEY]: Auth.membershipId() };
    localStorage.setItem(this.LOCALSTORAGE_KEY, JSON.stringify(initialFilters));
    return initialFilters;
  }

  store(membershipId: string, filters: unknown) {
    const list = this.load();
    list[membershipId] = filters;

    localStorage.setItem('worksFiltersByMembership', JSON.stringify(list));
  }

  load() {
    const raw = localStorage.getItem('worksFiltersByMembership');
    return raw ? JSON.parse(raw) : {};
  }
}

export default new Filters();
